import styled from 'styled-components';
export const Wrapper = styled.div `
  margin-top: ${({ useAvailableSpaceInMobile }) => useAvailableSpaceInMobile ? '112px' : 'auto'};

  margin-bottom: ${({ useAvailableSpaceInMobile }) => useAvailableSpaceInMobile ? '96px' : 'auto'};

  overflow-y: scroll;
  padding: 0.75rem;

  @media (min-width: 768px) {
    margin: auto;
    overflow-y: hidden;
    width: 482px;
  }
`;
